import { v4 as uuid4 } from "uuid";

export function createToastMessageID(): string {
  return uuid4();
}
